export type FinancialMetricCardKey =
  | 'revenue'
  | 'grossProfit'
  | 'ebitda'
  | 'cash'
  | 'netIncome'

export type FinancialMetricCardSelection = Record<
  FinancialMetricCardKey,
  string | null
>

export const DEFAULT_FINANCIAL_METRIC_CARD_LABELS: Record<
  FinancialMetricCardKey,
  string
> = {
  revenue: 'Total Revenue',
  grossProfit: 'Gross Profit',
  ebitda: 'EBITDA',
  cash: 'Cash & Cash Equivalents',
  netIncome: 'Net Income (Loss)',
}

export const EMPTY_FINANCIAL_METRIC_CARD_SELECTION: FinancialMetricCardSelection =
  {
    revenue: null,
    grossProfit: null,
    ebitda: null,
    cash: null,
    netIncome: null,
  }

export const OVERVIEW_CARD_ORDER: readonly FinancialMetricCardKey[] = [
  'revenue',
  'ebitda',
  'cash',
]

export const FINANCIALS_CARD_ORDER: readonly FinancialMetricCardKey[] = [
  'revenue',
  'grossProfit',
  'ebitda',
  'netIncome',
]

export function applyMetricCardSelection(
  current: FinancialMetricCardSelection,
  cardKey: FinancialMetricCardKey,
  metricLabelId: string,
  defaultMetricIdByCard: Partial<Record<FinancialMetricCardKey, string>>
): FinancialMetricCardSelection {
  const nextMetricLabelId =
    metricLabelId === defaultMetricIdByCard[cardKey] ? null : metricLabelId

  if (current[cardKey] === nextMetricLabelId) return current
  return { ...current, [cardKey]: nextMetricLabelId }
}

export function getFinancialChangeDisplay(
  changePercent: number | null,
  changeDisplay: 'AVAILABLE' | 'NOT_MEANINGFUL' | 'UNAVAILABLE'
): { value: string; isMeaningful: boolean } {
  if (changeDisplay === 'NOT_MEANINGFUL') {
    return { value: 'N/M', isMeaningful: false }
  }
  if (changeDisplay === 'UNAVAILABLE' || changePercent == null) {
    return { value: '—', isMeaningful: false }
  }

  const prefix = changePercent > 0 ? '+' : ''
  return {
    value: `${prefix}${changePercent.toFixed(1)}%`,
    isMeaningful: true,
  }
}
